import React from "react";
import type { RenderSiteProps } from "./RenderSite";
import { I18n } from "../i18n";

const RecaptchaDisclaimer: React.FC<
  Pick<RenderSiteProps["site"], "language">
> = ({ language }) => {
  const i18n = I18n(language);
  return (
    <p className="text-xs text-gray-600 ps-2">
      {i18n["This site is protected by"]}{" "}
      <a
        className="underline"
        href="https://developers.google.com/recaptcha/"
        target="_blank"
        rel="noopener noreferrer"
      >
        reCAPTCHA
      </a>{" "}
      {i18n["reCAPTCHA privacy conjunction"]}{" "}
      <a
        className="underline"
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        {i18n["Privacy Policy"]}
      </a>{" "}
      {i18n["reCAPTCHA terms conjunction"]}{" "}
      <a
        className="underline"
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener noreferrer"
      >
        {i18n["Terms of Service"]}
      </a>{" "}
      {i18n["reCAPTCHA legal suffix"]}
    </p>
  );
};

export const ContactForm: React.FC<RenderSiteProps> = (props) => {
  const i18n = I18n(props.site.language);
  if (!props.site?.contactForm) {
    return;
  }
  return (
    <section id="contact" className="py-16 bg-gray-50">
      <div className=" mx-auto px-6 max-w-7xl">
        <div className="text-center">
          {props.site.contactForm?.title && (
            <h2 className="text-4xl font-extrabold text-gray-800 mb-6 first-letter:uppercase">
              {props.site.contactForm.title}
            </h2>
          )}
          {props.site.contactForm?.description && (
            <p className="text-lg text-gray-600 mb-8 first-letter:uppercase">
              {props.site.contactForm.description}
            </p>
          )}
        </div>
        <div className="max-w-xl mx-auto bg-white p-8 rounded-lg shadow-lg mt-5">
          <form
            className="space-y-6"
            id="contact-form"
            action="/contact"
            method="POST"
          >
            <div>
              <input
                type="text"
                name="site_id"
                value={props.site.id}
                className="hidden"
                readOnly
              />
              <input
                type="email"
                id="email"
                name="email"
                placeholder={i18n["Your email address"]}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                required
              />
            </div>
            <div>
              <textarea
                id="message"
                name="message"
                rows={8}
                placeholder={i18n["Your message"]}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
                required
              ></textarea>
            </div>
            <div className="flex items-center justify-between gap-2">
              <RecaptchaDisclaimer language={props.site.language} />

              <button
                // type="submit"
                disabled
                data-sitekey="6LcmYkArAAAAAImj4hElAYe82hObX99G532X1iPx"
                data-callback="onContactFormSubmit"
                data-action="submit_contact_form"
                className={`g-recaptcha bg-${props.site.color}-500 text-white py-3 px-8 rounded-full shadow-lg hover:bg-primary-dark transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2`}
              >
                {i18n["Send"]}
              </button>
            </div>
          </form>
          <div
            id="contact-form-success"
            className={`hidden font-bold mt-4 text-${props.site.color}-600`}
          >
            {
              i18n[
                "Thank you for your interest! We will get back to you as soon as possible."
              ]
            }
          </div>
        </div>
      </div>
    </section>
  );
};
